// Utility function to truncate text
export const truncateText = (text: string, maxLength: number = 50): string => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  
  // Find the last space before the max length to avoid cutting words in half
  const truncated = text.substring(0, maxLength);
  const lastSpaceIndex = truncated.lastIndexOf(' ');
  
  // If there's a space and it's not too close to the beginning, cut at the space
  if (lastSpaceIndex > maxLength * 0.7) {
    return truncated.substring(0, lastSpaceIndex) + '...';
  }
  
  // Otherwise, just truncate at maxLength
  return truncated + '...';
};

// Specific function for widget titles with a reasonable default
export const truncateWidgetTitle = (title: string): string => {
  return truncateText(title, 40); // 40 characters should be good for widget titles
};

// Function for truncating user queries (can be a bit longer)
export const truncateUserQuery = (query: string): string => {
  return truncateText(query, 80); // 80 characters for user queries
};